<template>
  <nav class="top level">
    <div class="level-left">
      <div class="level-item breadcrumb has-bullet-separator" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link
              :class="{'is-active': name === 'index'}"
              :to="{ name: 'index' }">
              GamePlan
            </router-link>
          </li>
          <template v-for="route in $route.matched">
            <li v-if="route.meta.breadcrumb" :key="route.path">
              <router-link
                :to="{ name: route.meta.breadcrumb.linkName }">
                {{ route.meta.breadcrumb.linkText }}
              </router-link>
            </li>
          </template>
        </ul>
      </div>
      <slot class="level-item"></slot>
    </div>
    <div v-if="identity" class="level-right">
      <p v-if="siteEnv !== 'production'" class="level-item site">{{ siteEnv }}</p>
      <p class="level-item clock"><clock></clock></p>
      <p class="level-item">
        <a v-on:click="TOGGLE_USER_INFO" class="user-email right is-size-6">
          {{ identity.email }}<i class="fas fa-user-astronaut"></i>
        </a>
      </p>
    </div>
    <div v-else>
      <div v-if="user" class="level-right">
        <p class="level-item">
          <a v-on:click="TOGGLE_USER_INFO" class="right">
            {{ user.username }}<i class="fas fa-user-astronaut"></i>
          </a>
        </p>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import Clock from '@/components/Clock.vue';

export default {
  name: 'NavBar',
  components: { Clock },
  computed: {
    ...mapState(['siteEnv']),
    ...mapState('route', ['name']),
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['identity']),
  },
  methods: {
    ...mapMutations(['TOGGLE_USER_INFO']),
    logout() {
      this.$store.dispatch('auth/logoutUser');
      this.$router.push({ name: 'login' });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

nav {
  padding: 0 $content-padding;

  border-bottom: 1px solid $border-color;

  .breadcrumb {
    margin-bottom: 0;
  }

  a.right {
    svg {
      margin-left: 10px;
    }
  }

  .clock, .site {
    font-size: .8rem;
    color: $expression-background;
  }

  .site {
    color: $attention;
  }
}

</style>
